import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
    Paper,
    Grid,
    Box,
    Typography,
    Drawer,
    IconButton,
    useTheme,
    useMediaQuery,
    Tabs,
    Tab,
    Tooltip,
} from "@mui/material";
import { confirmAlert } from 'react-confirm-alert';
import { useNotifier } from "muinotify";
import './react-confirm-alert.css';
import api from "../../services/api";
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CloseIcon from '@mui/icons-material/Close';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import useSWR, { mutate } from "swr"
import CategoryTypeEdit from './category_type/update';
import CategoryTypeAdd from './category_type/create';
import CategoryItemEdit from './category_item/update';
import CategoryItemAdd from './category_item/create';

// function TabPanel(props) {
//     const { children, value, index, ...other } = props;
//     return (
//         <div
//             role="tabpanel"
//             hidden={value !== index}
//             id={`simple-tabpanel-${index}`}
//             aria-labelledby={`simple-tab-${index}`}
//             {...other}
//         >
//             {value === index && (
//                 <Box sx={{ p: 3 }}>
//                     {children}
//                 </Box>
//             )}
//         </div>
//     );
// }

// export const getUserIdFromToken = () => {
//     try {
//         const token = localStorage.getItem("token");
//         const decoded = jwtDecode(token);

//         return decoded.sub;
//     } catch (error) {
//         console.error("Failed to decode token:", error);
//         return null;
//     }
// };

const WindowTiles = ({ onClose, production, /*clientId*/ }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [isSubDrawerOpen, setIsSubDrawerOpen] = useState(false);
    const [tabValue, setTabValue] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const { notifier } = useNotifier();
    const [selectedCategoryType, setSelectedCategoryType] = useState(null);

    const { data: category_type, error: category_type_error, isLoading: category_type_loading, mutate: category_type_mutate } = useSWR(`/production-category-type/all_of_production/${production.id}`);
    const { data: category_item, error: category_item_error, isLoading: category_item_loading, mutate: category_item_mutate } = useSWR(`/production-category-item/of-production/${production.id}`);
    const { data: item_category_types } = useSWR('/production-category-item-type');

    // const [selectedCategoryType, setSelectedCategoryType] = useState([]);
    const [editId, setEditId] = useState(null);
    const [toAdd, setToAdd] = useState(false);
    const [activeModal, setActiveModal] = useState(null);

    // useEffect(() => {
    //     category_type && setSelectedCategoryType(category_type);
    // }, [category_type]);

    const handleDelete = useCallback((URL, id) => {
        confirmAlert({
            title: 'Confirm deletion',
            message: 'Are you sure you want to delete this record ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: async () => {
                        try {
                            await api.delete(`/${URL}/${id}`);
                            notifier("Record deleted successfuly", { variant: "success" });
                            await category_type_mutate();
                            await category_item_mutate();
                        } catch (err) {
                            notifier("Failed to delete record. " + err.message, { variant: "error" });
                        }
                    }
                },
                {
                    label: 'No',
                }
            ]
        });
    }, [mutate, notifier]);

    // const handlePanelClose = () => {
    //     setEditId(null);
    //     setIsDrawerOpen(false);
    // };

    const handlePanelCloseUpdate = () => {
        setEditId(null);
        setToAdd(false);
        setActiveModal(null)
        setIsSubDrawerOpen(false);
        category_type_mutate();
        category_item_mutate();
    };

    const handleAddCategoryType = () => {
        setActiveModal({ mode: 'add', type: 'category_type' });
    };

    const handleEditCategoryType = (id) => {
        setEditId(id);
        setActiveModal({ mode: 'edit', type: 'category_type', id });
    };

    const handleAddCategoryItem = () => {
        setActiveModal({ mode: 'add', type: 'category_item' });
    };

    const handleEditCategoryItem = (id) => {
        setEditId(id);
        setActiveModal({ mode: 'edit', type: 'category_item', id });
    };

    const handleCloseDrawer = () => {
        setIsSubDrawerOpen(false);
        onClose();
    };

    // const handleTabChange = (event, newValue) => {
    //     setTabValue(newValue);
    // };

    const category_type_flattened_data = Array.isArray(category_type)
        ? category_type.map((pruduction) => ({
            ...pruduction,
            pruduction: pruduction?.pc_pruduction?.p_descr || null,
            pruduction_id: pruduction?.pc_pruduction?.id || null,
        })) : [];

    const category_type_columns = [
        { field: 'pct_descr', headerName: 'Περιγραφή', flex: 1, headerAlign: 'center', },
        {
            field: 'pct_aa', headerName: 'A/A', flex: 1, headerAlign: 'center', renderCell: (params) => (
                <div
                    style={{
                        textAlign: 'center',
                    }}
                >
                    {params?.value || null}
                </div>
            ),
        },
        // {
        //     field: 'pruduction', headerName: 'Παραγωγή', flex: 1, headerAlign: 'center', renderCell: (params) => (
        //         <div
        //             style={{
        //                 textAlign: 'center',
        //             }}
        //         >
        //             {params.value}
        //         </div>
        //     ),
        // },
        {
            field: 'actions',
            type: 'actions',
            width: 100,
            headerName: "Actions",
            headerAlign: 'center',
            getActions: (params) => [
                <GridActionsCellItem color="primary" icon={<EditOutlinedIcon />} label="Edit" onClick={() => handleEditCategoryType(params.row.id)} />,
                <GridActionsCellItem color="secondary" icon={<DeleteOutlineOutlinedIcon />} label="Delete" onClick={() => handleDelete(`production-category-type`, params.row.id)} />,
            ],
        },
    ];

    const category_item_flattened_data = useMemo(() => {
        if (!Array.isArray(category_item)) return [];

        return category_item.map((pruduction) => ({
            ...pruduction,
            pruduction_name: pruduction?.prod_descr?.p_descr || null,
            pruduction_id: pruduction?.prod_descr?.id || null,
            pci_type_descr:
                item_category_types?.find((type) => type.id === pruduction.pci_type)
                    ?.pcit_descr || null,
        }));
    }, [category_item, item_category_types]);

    const category_item_columns = [
        {
            field: 'pci_aa',
        },
        // {
        //     field: 'pruduction_name', headerName: 'Παραγωγή', flex: 0.5, minWidth: 300,
        //     maxWidth: 500, headerAlign: 'center', renderCell: (params) => {
        //         return (
        //             <>
        //                 <div>
        //                     {params.value}
        //                 </div>
        //             </>
        //         );
        //     },
        // },
        {
            field: 'pci_descr', headerName: 'Περιγραφή', flex: 1, minWidth: 300,
            maxWidth: 300, headerAlign: 'center',
        },
        {
            field: 'pci_type_descr',
            headerName: 'Τρόπος Τιμολόγησης',
            flex: 1,
            minWidth: 140,
            headerAlign: 'center',
        },
        {
            field: 'pci_amount',
            headerName: 'Προϋπολογισμός',
            flex: 1,
            minWidth: 50,
            maxWidth: 185,
            headerAlign: 'center',
            renderCell: (params) => {
                if (params.value == null) {
                    return null;
                }

                const formattedAmount = new Intl.NumberFormat('en-IE', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(parseFloat(params.value));

                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'right',
                        alignItems: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%'
                    }}>
                        {formattedAmount}
                    </div>
                );
            },
        },
        { field: 'pci_notes', headerName: 'Παρατηρήσεις', flex: 1, headerAlign: 'center', },
        {
            field: 'actions',
            type: 'actions',
            width: 100,
            headerName: "Actions",
            headerAlign: 'center',
            getActions: (params) => [
                <GridActionsCellItem color="primary" icon={<EditOutlinedIcon />} label="Edit" onClick={() => handleEditCategoryItem(params.row.id)} />,
                <GridActionsCellItem color="secondary" icon={<DeleteOutlineOutlinedIcon />} label="Delete" onClick={() => handleDelete(`production-category-item`, params.row.id)} />,
            ],
        },
    ];

    const gridContainerStyle = useMemo(() => ({
        flex: 1,
        overflow: 'auto',
        maxHeight: '100%',
    }), []);

    const paperStyle = useMemo(() => ({
        height: 'calc(100vh - 12vh)',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        overflow: 'hidden',
        padding: theme.spacing(1),
    }), []);

    const filteredCategoryItems = useMemo(() => {
        if (!selectedCategoryType)
            return category_item_flattened_data;

        return category_item_flattened_data.filter(item =>
            // item.pruduction_id === selectedCategoryType.pruduction_id &&
            item.pc_type_id === selectedCategoryType.id);
    }, [selectedCategoryType, category_item_flattened_data]);

    return (
        <Drawer
            anchor={isMobile ? "bottom" : "right"}
            open={isDrawerOpen}
            onClose={handleCloseDrawer}
            sx={{
                "& .MuiDrawer-paper": {
                    width: isMobile ? "100%" : "100%",
                    height: isMobile ? "80%" : "100%",
                    p: 2,
                }
            }}
        >
            <Box>
                <Box display="flex" justifyContent="space-between">
                    <div>
                        <Typography variant="h4">{production?.p_descr || null}</Typography>
                        {/* <Typography variant="subtitle1" color="textSecondary">
                            {clientData?.clientName2 || "N/A"} • {'ID: ' + clientData?.clientId || "N/A"}
                        </Typography> */}
                    </div>
                    <IconButton
                        onClick={handleCloseDrawer}
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* <Tabs value={tabValue} onChange={handleTabChange} aria-label="client tabs">
                    <Tab label="Dashboard" />
                    <Tab label="Details" />
                    <Tab label="Other" />
                </Tabs>

                <TabPanel value={tabValue} index={0}  >
                    <Typography variant="h4" gutterBottom textAlign={"center"}>Client Details</Typography>
                    <Box flex={1} justifyContent={"center"} justifyItems={"center"}>
                        <Paper elevation={3} sx={{ width: "20vw" }} >
                            <Typography>Client ID: {clientData?.clientId || "N/A"}</Typography>
                            <Typography>Primary Contact: {clientData?.contactPerson || "N/A"}</Typography>
                            <Typography>Email: {clientData?.clientEmail || "N/A"}</Typography>
                            <Typography>Phone: {clientData?.clientPhone || "N/A"}</Typography>
                            <Typography>Address: {clientData?.clientAddress || "N/A"}</Typography>
                        </Paper>
                    </Box>
                </TabPanel> */}

                {/* <TabPanel value={tabValue} index={1}> */}
                <Grid container spacing={3} sx={gridContainerStyle}>

                    <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }}>
                            <Typography variant="h4">Τύπος κατηγορίας</Typography>
                            <Tooltip title="Προσθήκη Τύπου κατηγορίας">
                                <IconButton
                                    color="primary"
                                    onClick={handleAddCategoryType}
                                >
                                    <AddCircleOutlineIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <Paper elevation={3} sx={paperStyle}>
                            <DataGrid
                                // initialState={{
                                //     sorting: {
                                //         sortModel: [{ field: 'clientCallId', sort: 'desc' }],
                                //     },
                                // }}
                                // columnVisibilityModel={{
                                //     clientCallId: false,
                                // }}
                                onRowClick={(params) => setSelectedCategoryType(params.row)}
                                rows={category_type_flattened_data || []}
                                columns={category_type_columns}
                                getRowId={(row) => row.id}
                                density="compact"
                                // hideFooter
                                sx={{
                                    flex: 1,
                                    minHeight: 250,
                                    '& .MuiDataGrid-virtualScroller': { overflow: 'auto' }
                                }}
                            />
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }}>
                            <Typography variant="h4">Είδος Δαπάνης</Typography>
                            <Tooltip title="Προσθήκη Είδους Δαπάνης">
                                <IconButton
                                    color="primary"
                                    onClick={handleAddCategoryItem}
                                >
                                    <AddCircleOutlineIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <Paper elevation={3} sx={paperStyle}>
                            <DataGrid
                                initialState={{
                                    sorting: {
                                        sortModel: [{ field: 'pci_aa', sort: 'asc' }],
                                    },
                                }}
                                columnVisibilityModel={{
                                    id: false,
                                    pci_aa: false,
                                }}

                                rows={filteredCategoryItems || (category_item_flattened_data || [])}
                                columns={category_item_columns}
                                getRowId={(row) => row.id}
                                density="compact"
                                // hideFooter
                                sx={{
                                    flex: 1,
                                    minHeight: 250,
                                    '& .MuiDataGrid-virtualScroller': { overflow: 'auto' }
                                }}
                            />
                        </Paper>
                    </Grid>
                </Grid>

                <Drawer
                    anchor="right"
                    open={activeModal !== null}
                    onClose={handlePanelCloseUpdate}
                >
                    {activeModal?.mode === 'edit' && activeModal?.type === 'category_type' && (
                        <CategoryTypeEdit
                            onClose={handlePanelCloseUpdate}
                            id_from_drawer={editId}
                        />
                    )}

                    {activeModal?.mode === 'add' && activeModal?.type === 'category_type' && (
                        <CategoryTypeAdd
                            prod_id={production.id}
                            onClose={handlePanelCloseUpdate}
                        />
                    )}

                    {activeModal?.mode === 'edit' && activeModal?.type === 'category_item' && (
                        <CategoryItemEdit
                            onClose={handlePanelCloseUpdate}
                            id_from_drawer={editId}
                        />
                    )}

                    {activeModal?.mode === 'add' && activeModal?.type === 'category_item' && (
                        <CategoryItemAdd
                            prod_id={production.id}
                            category_type_data={selectedCategoryType}
                            onClose={handlePanelCloseUpdate}
                        />
                    )}

                </Drawer>


                {/* <TabPanel value={tabValue} index={2}>
                    <Typography variant="h5" gutterBottom>Extra</Typography>
                    <Paper elevation={3} sx={{ p: 2 }}>
                        <Typography>Extra</Typography>
                    </Paper>
                </TabPanel> */}
            </Box>
        </Drawer >
    );
};

export default WindowTiles;